import { render, staticRenderFns } from "./PersonalCardTypeAdd.vue?vue&type=template&id=b91e5a5c&"
import script from "./PersonalCardTypeAdd.vue?vue&type=script&lang=js&"
export * from "./PersonalCardTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports